import { FC } from 'react'
import { css } from '@emotion/react'
import { palette } from '@lifedot/styles/palette'
import { typography } from '@lifedot/styles/typography'

const styles = {
  fontWeightBold: css({
    fontWeight: 'bold'
  }),
  price: css({
    color: palette.alert
  })
}

type PriceDataRowProps = {
  name: string | null
  purchasePrice: {
    price: string
    unit: string
    supplement: string
    managementFee: string
  }
}

export const PriceDataRow: FC<PriceDataRowProps> = ({
  name,
  purchasePrice
}) => {
  return (
    <tr>
      <td css={styles.fontWeightBold}>{name}</td>
      <td css={styles.price}>
        <span
          css={[purchasePrice.price && typography.textM, styles.fontWeightBold]}
        >
          {purchasePrice.price}
          {purchasePrice.supplement}
        </span>
        <small>{purchasePrice.unit}</small>
      </td>
      <td>{purchasePrice.managementFee}</td>
    </tr>
  )
}
